import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="scroll-to-error"
export default class extends Controller {
  connect() {
    const errorElement = this.element.querySelector(".is-invalid");

    if (errorElement) {
      errorElement.scrollIntoView({
        block: "center",
        behavior: "instant",
      });

      errorElement.focus();
    }
  }
}
